module.exports = __webpack_public_path__ + "media/images/responsive/costumes/category_icons/kimono/new-1fe767ab687fa2e13f392e5084cddbe5.jpg";